import React from 'react';
// import React from 'react-native-elements';
import {Query} from 'react-apollo';
import {useQuery} from "@apollo/client";
import {GET_WORKSHOP_LIST} from "../query";
import {clientExternalV2, clientV2} from "../../../common";
import {View, Text} from "react-native";

interface IGetWorkshopListDataProps {
    isJobRowAssignable: boolean;
    children: (workshopList: object[]) => JSX.Element;
}

export const GetWorkshopListData = (props: IGetWorkshopListDataProps) => {
    const {data, loading, error} = useQuery(GET_WORKSHOP_LIST,
        {
            client: clientExternalV2,
            variables: {isJobRowAssignable: props.isJobRowAssignable},
            fetchPolicy: 'cache-first'
        });
    if (loading || error) return <View><Text>Loading</Text></View>;
    const {workshopList} = data;
    return props.children(workshopList);
};